module.exports = __webpack_public_path__ + "static/img/credit-wuhu-3.edfdf925.jpg";